import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Campaign } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/whatsapp-provider" component={Campaign} />
);
export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/WhatsAppProvider/routes.js